"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Calendar(props) {
  return _react.default.createElement(_semanticUiReact.Table, {
    unstackable: true,
    celled: true,
    textAlign: "center"
  }, props.children);
}

Calendar.handledProps = ["children"];
Calendar.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = Calendar;
exports.default = _default;